// @TODO: <HEALTH2019>
(function () {
    App.directive('inputTime', inputTimeDirective);
    inputTimeDirective.$inject = ['Config'];

    function inputTimeDirective(Config) {
        return {
            restrict: 'E',
            scope: {
                form: '<',
                name: '@',
                label: '@',
                required: '<',
                model: '=',
                modelChange: '&',
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/input-time.html',
            controller: InputTimeController,
            controllerAs: '$ctrl',
            bindToController: true
        }
    }

    InputTimeController.$inject = ['$scope'];
    function InputTimeController($scope) {
        var self = this;

        self.innerModel = '';

        self.$onInit = function () {
            observeInnerModel();
        };

        function observeInnerModel() {
            $scope.$watch('$ctrl.innerModel', function () {
                if (self.innerModel && self.innerModel.length && self.innerModel.length === 4) {
                    var splitted = [self.innerModel.substr(0, 2), self.innerModel.substr(2, 2)];

                    if (parseInt(splitted[0], 10) > 23) splitted[0] = '23';
                    if (parseInt(splitted[1], 10) > 59) splitted[1] = '59';

                    self.innerModel = splitted.join('');

                    self.model = splitted.join(':');
                } else {
                    self.model = null;
                }

                self.modelChange && self.modelChange({$event: self.model});
            }, true);
        }
    }
})();
// @TODO: </HEALTH2019>
